import React, {Component} from 'react';
import Select from 'react-select';
import {Redirect} from 'react-router-dom';

import 'react-select/dist/react-select.css';


class Input extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedOption: '',
            redirect: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.goToPage = this.goToPage.bind(this);

    }

    goToPage() {
        if(this.state.selectedOption) {
            this.setState({redirect: true})
        }
    }

    handleChange(selectedOption) {
        this.setState({selectedOption});
        setTimeout(function () {
            this.setState({redirect: true})
        }.bind(this), 200);

    }



    render() {
        const searchbar = [];
        this.props.data.forEach(function(r) {
            let name;
            if(r["Publication Name"] === "The Workshop School") {
                name = r["Publication Name"];
            } else {
                name = r["Publication Name"].replace(/ School\s*$/m, '');
            }
            searchbar.push({value: r["Link with ULCS"], label: name})
        })

        const {selectedOption} = this.state;
        const value = selectedOption && selectedOption.value;

        if (this.state.redirect && this.state.selectedOption) {
            return (
                <Redirect push to={`/schools/${value}`}/>
            )

        } else {
            return (
                <div className="selection-area">
                    <Select name="form-field-name" placeholder={this.props.placeholder} value={value} onChange={this.handleChange} options={searchbar}/>
                    <button className="gobutton" onClick={this.goToPage}>
                        Go
                    </button>

                </div>
            )
        }
    }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/AutoComplete.js